<template>
  <section class="well should-you-bluff-reasoning-help-section-1 help-section">
    <p>The overarching formula is <code>risk / (risk + reward)</code>.</p>
    <p>Here's an example. If the pot is $2 and you want to try a 1/2 pot bluff, your bluff would be $1. You're risking $1 to win $2.</p>
<pre>
risk = $1
reward = $2
breakeven percentage = risk / (risk + reward)
breakeven percentage = 1 / (1 + 2)
breakeven percentage = 1 / 3
breakeven percentage = 33.3%
</pre>
    <p>This formula actually isn't specific to poker at all. Suppose that the Steelers and Saints are in the Super Bowl and if you bet on the Steelers, the casino will give you $2 for every $1 you bet if you win, plus your money back. So if you bet $100, you'd get your $100 back, plus another $200. How often do you need to win this bet to break even? It's the same thing: <code>risk / (risk + reward)</code>.</p>
<pre>
risk = $100
reward = $200
breakeven percentage = risk / (risk + reward)
breakeven percentage = 100 / (100 + 200)
breakeven percentage = 100 / 300
breakeven percentage = 33.3%
</pre>
    <p>As a sanity check, ask yourself what happens if you win the bet once and lose it twice. First you win, and you're up $200. Then you lose, and you're up $100. Then you lose again, and you're even. When you win 33.3% of the time, you break even.</p>
    <p>And for those of you interested in the math, here is the derivation. We start off with <code>(reward)(% success) = (risk)(1 - %success)</code> because we're interested in knowing what <code>% success</code> leads to the risk balancing out the reward. From there it's just a little algebra.</p>
<pre>
(reward)(%success) = (risk)(1 - %success)
(reward)(%success) = risk - (risk)(%success)
(reward)(%success) + (risk)(%success) = risk
%success(reward + risk) = risk
%success = risk / (risk + reward)
</pre>
  </section>
</template>

<script>
export default {
  name: 'should-you-bluff-reasoning-help-section-1',
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/help-section';
</style>



// WEBPACK FOOTER //
// src/components/guided-analyses/should-you-bluff/help/reasoning-1.vue